function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useEffect, useState } from "react";
import { getPersonalizationClientId, useLaunchDarklyFlag } from "../utils/ld-cache";
import { set as SetStorage, get as GetStorage } from "../utils/storage";
import { captureException } from "@lululemon/mwa-utils";
import getSatelliteScript from "../analytics/receivers/satellite/getSatelliteScript";
import { deliveryModes } from "../utils/lpe-cache/apis/delivery";
var storageName = "AB_TESTING_DELIVERY_MODE";
export var useAbTestingDeliveryMode = function() {
    var getRandomItemFromArray = function getRandomItemFromArray(array) {
        return array[Math.floor(Math.random() * array.length)];
    };
    var _useState = _sliced_to_array(useState(null), 2), tracking = _useState[0], setTracking = _useState[1];
    var _useLaunchDarklyFlag = _sliced_to_array(useLaunchDarklyFlag("ab-testing-delivery-mode", false, {
        clientId: getPersonalizationClientId()
    }), 1), deliveryModeFlag = _useLaunchDarklyFlag[0];
    useEffect(function() {
        if (!tracking) return;
        //give 5 seconds for analytics module to actually load, due to issue https://github.com/Lululemon/mwa-libraries/issues/1274
        var timeout = setTimeout(function() {
            getSatelliteScript().then(function(satellite) {
                satellite.track("target-A4L", {
                    list1: "abt-1984-targetDirectDeliveryCall-" + tracking,
                    deferred: true
                });
            }).catch(function(err) {
                captureException(err, "error");
            });
        }, 5000);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        tracking
    ]);
    useEffect(function() {
        try {
            var storageValue = GetStorage(storageName);
            var deliveryMode = deliveryModes[deliveryModeFlag];
            if (deliveryMode === deliveryModes.TEST && storageValue === null) {
                var mode = getRandomItemFromArray([
                    deliveryModes.DIRECT,
                    deliveryModes.AKAMAI,
                    deliveryModes.LPE
                ]);
                SetStorage(storageName, mode, {
                    expires: 14
                });
                setTracking(mode);
            } else if (deliveryMode === deliveryModes.TEST && storageValue) {
                setTracking(storageValue);
            } else if (deliveryMode === deliveryModes.LPE || deliveryMode === deliveryModes.DIRECT || deliveryMode === deliveryModes.AKAMAI) {
                SetStorage(storageName, deliveryMode, {
                    expires: 1
                });
            } else {
                SetStorage(storageName, deliveryModes.LPE, {
                    expires: 1
                });
            }
        } catch (err) {
            captureException(err, "error");
        }
    }, [
        deliveryModeFlag
    ]);
};

//# sourceMappingURL=useAbTestingDeliveryMode.js.map